"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FetchHelper_1 = __importDefault(require("../../helpers/FetchHelper"));
const filterBoolean_1 = __importDefault(require("../../util/filterBoolean"));
const unwrap_1 = __importDefault(require("../../util/unwrap"));
const checkStatus_1 = __importDefault(require("./checkStatus"));
class GoogleMapsController {
    static async request(service, parameters, options) {
        // url
        let url = `https://maps.googleapis.com/maps/api/${service}/json?`;
        // parameters
        const params = new URLSearchParams();
        for (const parameter of parameters) {
            params.append(parameter[0], parameter[1]);
        }
        params.append('key', options.apiKey);
        url += params.toString();
        // headers
        const headers = (0, filterBoolean_1.default)([
            (0, unwrap_1.default)(options === null || options === void 0 ? void 0 : options.bundleIdentifier, id => ['x-ios-bundle-identifier', id]),
        ]);
        // request
        const response = await FetchHelper_1.default.fetch(url, { headers });
        // check response
        const result = (await response.json());
        (0, checkStatus_1.default)(result);
        return result;
    }
}
exports.default = GoogleMapsController;
